import { render, staticRenderFns } from "./selectedUserUnit.vue?vue&type=template&id=267c35c6&scoped=true&"
import script from "./selectedUserUnit.vue?vue&type=script&lang=tsx&"
export * from "./selectedUserUnit.vue?vue&type=script&lang=tsx&"
import style0 from "./selectedUserUnit.vue?vue&type=style&index=0&id=267c35c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267c35c6",
  null
  
)

export default component.exports